import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=16f12f7c&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=16f12f7c&lang=scss&scoped=true&"
import style1 from "./Payment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f12f7c",
  null
  
)

export default component.exports